import React from 'react'
import FormCreateSponsor from '../components/sponsors-create-page/FormCreateSponsor'
import Breadcrumb from '../../core/components/UI/Breadcrumb'

export default function SponsorCreatePage() {
  const links = [
    {
      id: 1,
      label: 'الرعاة',
      isActive: false,
      to: '/sponsors',
    },
    {
      id: 2,
      label: 'اضافة الراعي',
      isActive: true,
      to: '/sponsors/create',
    },
  ]
  return (
    <>
      <Breadcrumb links={links} />
      <div className="p-2 bg-white border-2 border-muted-500">
        <FormCreateSponsor />
      </div>
    </>
  )
}
